import errorLog from '../../util/errorLog';
import isError from 'lodash/isError';
// eslint-disable-next-line no-unused-vars
export default function errorLogger(store) {
  return next => action => {
    if (action.error && isError(action.error)) {
      let level = action.error.level;
      if (!level) {
        // Use level based on any response status code.
        // 4xx responses are warnings, everything else is an error.
        const status = action.error.status;
        if (status && status >= 400 && status < 500) {
          level = 'warn';
        } else {
          level = 'error';
        }
      }
      if (action.message) {
        errorLog[level](action.message, action.error);
      } else {
        errorLog[level](action.error);
      }
    }

    return next(action);
  };
}



// WEBPACK FOOTER //
// ./js/store/config/errorLogger.js